import { InputAdornment, TextField } from '@mui/material'
import { useState } from 'preact/hooks'
import { SLUG_PATTERN, slugify } from './slug'

/** The slug typed by the user, or else the one suggested by the event name. */
export function useSlug(name: string) {
  const [typed, setTyped] = useState<string>()
  return [typed ?? slugify(name), setTyped] as const
}

export function SlugField({
  value,
  onChange,
}: {
  value: string
  onChange: (slug: string) => void
}) {
  return (
    <TextField
      label="Adresse"
      required
      helperText="Lettres minuscules, chiffres et tirets ; changer d'adresse ensuite casse les liens partagés"
      slotProps={{
        htmlInput: { pattern: SLUG_PATTERN, minLength: 3, maxLength: 64 },
        input: { startAdornment: <InputAdornment position="start">/events/</InputAdornment> },
      }}
      value={value}
      onInput={(e) => onChange((e.target as HTMLInputElement).value)}
    />
  )
}
